import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, TableFooter } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import tokenDecoder from '../../../utils/tokenDecoder';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import PageHeader from 'src/views/Common/PageHeader';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    table: {
        minWidth: 550,
    },
}));

const screenCode = "GREENLEAFRECEIVING"
export default function GreenLeafReceivingListing() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [title, setTitle] = useState("Green Leaf Receiving");
    const [groups, setGroups] = useState();
    const [factory, setFactory] = useState([]);
    const [estates, setEstates] = useState([]);
    const [estatesList, setEstatesList] = useState([]);
    const [leafTypes, setLeafTypes] = useState([]);
    const [fields, setFields] = useState([]);
    const [divisions, setDivisions] = useState();
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [mappingArray, setMappingArray] = useState([]);
    const [groupedData, setGroupedData] = useState({});
    const [IDDataForDeduction, setIsIDDataForDeduction] = useState(null);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [selectedData, setselectedData] = useState({
        greenLeafReceivingDetailsID: 0,
        leafTypeID: 0,
        leafWeight: 0,
        estateID: 0,
        date: ''
    });
    const [GreenLeafReceivingDetails, setGreenLeafReceivingDetails] = useState({
        groupID: 0,
        leafTypeID: 0,
        estateID: 0,
        factoryID: 0,
        leafWeight: 0,
        supplierID: 0,
        routeID: 0,
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isRegionFilterEnabled: false
    });
    const [totalaValus, setTotalaValus] = useState({
        totalWeight: 0,
        totalBoughtLfWeight: 0,
    });

    function calculateTotalValues(data) {
        const totalWeight = data.reduce((acc, item) => acc + (parseFloat(item.leafWeight) || 0), 0);
        setTotalaValus({
            ...totalaValus,
            totalWeight: totalWeight,
        });
    }

    let encrypted = "";
    const handleClickAdd = () => {
        encrypted = btoa('0');
        navigate('/app/GreenLeafReceiving/addedit/' + encrypted);
    }

    const handleClickEdit = (greenLeafReceivingDetailsID) => {
        encrypted = btoa(greenLeafReceivingDetailsID.toString());
        let model = {
            groupID: parseInt(GreenLeafReceivingDetails.groupID),
            leafTypeID: parseInt(GreenLeafReceivingDetails.leafTypeID),
            estateID: parseInt(GreenLeafReceivingDetails.estateID),
            fromDate: fromDate,
            toDate: toDate
        }
        sessionStorage.setItem('greenLeafReceiving-page-search-parameters-id', JSON.stringify(model));
        navigate('/app/GreenLeafReceiving/addedit/' + encrypted);
    }

    async function handleClickDelete(rowData) {
        setDeleteConfirmationOpen(true);
        setselectedData({
            ...selectedData,
            greenLeafReceivingDetailsID: rowData.greenLeafReceivingDetailsID,
            leafTypeID: rowData.leafTypeID,
            leafWeight: rowData.leafWeight,
            estateID: parseInt(rowData.factoryID),
            date: new Date(rowData.collectedDate).toISOString().split('T')[0]
        })
    }

    const handleConfirmDelete = async () => {
        setDeleteConfirmationOpen(false);
        let model = {
            greenLeafReceivingDetailsID: parseInt(selectedData.greenLeafReceivingDetailsID),
            leafTypeID: parseInt(selectedData.leafTypeID),
            leafWeight: selectedData.leafWeight,
            estateID: parseInt(selectedData.estateID),
            date: selectedData.date,
            modifiedBy: parseInt(tokenService.getUserIDFromToken())
        }
        const res = await services.DeleteGreenLeafReceivingDetails(model);
        if (res.statusCode == "Success") {
            alert.success(res.message)
            trackPromise(searchGreenLeafReceivingData())
        }
        else {
            alert.error(res.message)
        }
    };

    const handleCancelDelete = () => {
        setDeleteConfirmationOpen(false);
    };

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), GetAllLeafType());
    }, []);

    useEffect(() => {
        setMappingArray([]);
    }, [fromDate])

    useEffect(() => {
        setMappingArray([]);
    }, [toDate])

    useEffect(() => {
        if (GreenLeafReceivingDetails.groupID > 0) {
            getEsatesForDropdown(GreenLeafReceivingDetails.groupID);
        }
    }, [GreenLeafReceivingDetails.groupID]);

    useEffect(() => {
        if (
            GreenLeafReceivingDetails.groupID > 0) {
            getEstateDetailsByGroupID(GreenLeafReceivingDetails.groupID);
        }
    }, [GreenLeafReceivingDetails.groupID, GreenLeafReceivingDetails.leafTypeID]);

    useEffect(() => {
        if (GreenLeafReceivingDetails.groupID > 0) {
            getFactoryDetailsByGroupID(GreenLeafReceivingDetails.groupID);
        }
    }, [GreenLeafReceivingDetails.groupID, GreenLeafReceivingDetails.leafTypeID]);

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('greenLeafReceiving-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);

    useEffect(() => {
        if (IDDataForDeduction !== null) {
            searchGreenLeafReceivingData();
        }
    }, [IDDataForDeduction]);

    useEffect(() => {
        sessionStorage.removeItem(
            'greenLeafReceiving-page-search-parameters-id'
        );
    }, []);
    async function getPermissions(IDdata) {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGREENLEAFRECEIVING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isRegionFilterEnabled = permissions.find(p => p.permissionCode == 'REGIONDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isRegionFilterEnabled: isRegionFilterEnabled !== undefined,
        });

        const initialValues = IDdata === null;
        if (initialValues) {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                estateID: parseInt(tokenService.getFactoryIDFromToken())
            })
        }
        else {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                groupID: parseInt(IDdata.groupID),
                leafTypeID: parseInt(IDdata.leafTypeID),
                factoryID: parseInt(IDdata.estateID),
                estateID: parseInt(IDdata.estateID),
            })
            setToDate(IDdata.toDate)
            setFromDate(IDdata.fromDate)
            setIsIDDataForDeduction(IDdata)
        }
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getEsatesForDropdown(groupID) {
        const factories = await services.getEstateByGroupID(groupID);
        setEstatesList(factories);
    }

    async function getEstateDetailsByGroupID(groupID) {
        let operationEntityTypeID = 1
        const response = await services.getEstateDetailsByGroupID(groupID, operationEntityTypeID);
        setEstates(response);
    }

    async function getFactoryDetailsByGroupID(groupID) {
        let operationEntityTypeID = 2
        const response = await services.getFactoryDetailsByGroupID(groupID, operationEntityTypeID);
        setFactory(response);
    }

    async function GetAllLeafType() {
        const response = await services.GetAllLeafType();
        setLeafTypes(response);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            const entries = Object.entries(data);
            entries.sort((a, b) => a[1].localeCompare(b[1]));
            for (const [key, value] of entries) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function clearData() {
        setGreenLeafReceivingDetails({
            ...GreenLeafReceivingDetails,
            groupID: tokenDecoder.getGroupIDFromToken(),
            leafTypeID: 0,
            estateID: 0,
        });
        setMappingArray([]);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        if (name === "groupID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                leafTypeID: 0,
                estateID: 0,
                factoryID: 0,
            });
        }
        else if (name === "estateID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                factoryID: 0,
                leafTypeID: 0,
            });

        }
        else if (name === "leafTypeID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                factoryID: 0,
            });
        }
        else if (name === "routeID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                supplierID: 0,
            });

        }
        else {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value
            });
        }
        setMappingArray([])
    }
    async function searchGreenLeafReceivingData() {
        setMappingArray([]);
        let model = {
            groupID: parseInt(GreenLeafReceivingDetails.groupID),
            leafTypeID: parseInt(GreenLeafReceivingDetails.leafTypeID),
            estateID: parseInt(GreenLeafReceivingDetails.estateID),
            fromDate: fromDate,
            toDate: toDate
        }
        var response = await services.getGreenLeafReceivingData(model);
        if (response.data == null) {
            alert.error('No record to Display')
        }
        else {
            const groupedData = response.data.reduce((acc, item) => {
                const key = item.leafTypeID;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});

            const sortedGroupedData = Object.keys(groupedData)
                .sort((a, b) => parseInt(a) - parseInt(b))
                .reduce((obj, key) => {
                    obj[key] = groupedData[key];
                    return obj;
                }, {});
            setMappingArray(response.data);
            setGroupedData(sortedGroupedData);
            calculateTotalValues(response.data);
        }
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClickAdd}
                        isEdit={true}
                        toolTiptitle={"Green Leaf Receiving"}
                    />
                </Grid>
            </Grid>
        )
    }
    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title={title}
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: GreenLeafReceivingDetails.groupID,
                            leafTypeID: GreenLeafReceivingDetails.leafTypeID,
                            estateID: GreenLeafReceivingDetails.estateID,
                            factoryID: GreenLeafReceivingDetails.factoryID,
                            fromDate: fromDate,
                            toDate: toDate
                        }}

                        validationSchema={Yup.object().shape({
                            groupID: Yup.number().required('Group required').min(1, 'Group is required'),
                            estateID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
                        })}
                        onSubmit={searchGreenLeafReceivingData}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={2}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="estateID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.estateID && errors.estateID)}
                                                            fullWidth
                                                            helperText={touched.estateID && errors.estateID}
                                                            size='small'
                                                            name="estateID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.estateID}
                                                            variant="outlined"
                                                            id="estateID"
                                                            InputProps={{ readOnly: !permissionList.isFactoryFilterEnabled }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(estatesList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="leafTypeID">
                                                            Leaf Type
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            name="leafTypeID"
                                                            size='small'
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.leafTypeID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select Leaf Type--</MenuItem>
                                                            {generateDropDownMenu(leafTypes)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="fromDate" style={{ marginBottom: '-8px' }}>
                                                            From Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="fromDate"
                                                                value={fromDate}
                                                                onChange={(e) => {
                                                                    setFromDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                inputProps={{ readOnly: true }}
                                                                maxDate={toDate}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="toDate" style={{ marginBottom: '-8px' }}>
                                                            To Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="toDate"
                                                                value={toDate}
                                                                onChange={(e) => {
                                                                    setToDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                inputProps={{ readOnly: true }}
                                                                minDate={fromDate}
                                                                maxDate={new Date()}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                </Grid>
                                                <Grid container justify="flex-end" spacing={3}>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="outlined"
                                                            type="reset"
                                                            onClick={clearData}
                                                            size='small'
                                                        >
                                                            Clear
                                                        </Button>
                                                    </Box>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            type="submit"
                                                            size='small'
                                                        >
                                                            {"Search"}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </CardContent>
                                            {mappingArray.length > 0 && (
                                                <TableContainer component={Paper}>
                                                    <Table size='small'>
                                                        {Object.entries(groupedData).map(([key, items]) => (
                                                            <>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Estate</TableCell>
                                                                        <TableCell>Leaf Type</TableCell>
                                                                        <TableCell>Route</TableCell>
                                                                        <TableCell>Supplier</TableCell>
                                                                        <TableCell style={{ textAlign: 'center' }}>Collected Date</TableCell>
                                                                        <TableCell style={{ textAlign: 'right' }}>Leaf Weight</TableCell>
                                                                        <TableCell style={{ textAlign: 'right' }}>Actions</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {items.map((row, index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell>{row.factoryName}</TableCell>
                                                                            <TableCell>{row.leafTypeName}</TableCell>
                                                                            <TableCell>{row.routeName}</TableCell>
                                                                            <TableCell>{row.supplierName}</TableCell>
                                                                            <TableCell style={{ textAlign: 'center' }}>
                                                                                {new Date(row.collectedDate).toISOString().split('T')[0]}
                                                                            </TableCell>
                                                                            <TableCell style={{ textAlign: 'right' }}>
                                                                                {parseFloat(row.leafWeight).toLocaleString(undefined, {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </TableCell>                                                                    
                                                                            <TableCell style={{ textAlign: 'right' }}>
                                                                                <IconButton onClick={() => handleClickEdit(row.greenLeafReceivingDetailsID)}>
                                                                                    <Edit color="black" />
                                                                                </IconButton>
                                                                                <IconButton onClick={() => handleClickDelete(row)}>
                                                                                    <Delete color="black" />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </>
                                                        ))}
                                                        <TableFooter>
                                                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                                                <TableCell align="Right" colSpan={5} style={{ fontWeight: 'bold', textAlign: 'left', borderTop: '2px solid #e0e0e0', color: 'black', fontSize: '16px' }}>
                                                                    Total:
                                                                </TableCell>
                                                                <TableCell align="Right" style={{ fontWeight: 'bold', borderTop: '2px solid #e0e0e0', color: 'black', fontSize: '16px' }}>
                                                                    {totalaValus.totalWeight.toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </TableCell>
                                                                <TableCell align="Right" style={{ fontWeight: 'bold', borderTop: '2px solid #e0e0e0', color: 'black' }}>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableFooter>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                                <Dialog open={deleteConfirmationOpen} onClose={handleCancelDelete}>
                                    <DialogTitle>Delete Confirmation</DialogTitle>
                                    <DialogContent>
                                        <p>Are you sure, you want to delete this record?</p>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleConfirmDelete} color="primary">
                                            Delete
                                        </Button>
                                        <Button
                                            onClick={handleCancelDelete} color="primary">
                                            Cancel
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page >
        </Fragment >
    )
}
